export const SEARCH_FORM = "admin_user_search";
export const REQUEST_LOGIN_FORM = "request_login";
export const PAYMENT_INTEREST_FORM = "payment_interest_form";
export const RESET_LINK_REQUEST = "reset_link_request";
export const EMAIL_CONFIRM_LINK_REQUEST = "email_confirm_link_request";
export const PAGE_COUNT = 200;
export const VERIFY_FORM = "admin_user_verify";
export const ADMIN_UPDATE_ACCOUNT_TYPE_FORM = "admin_update_account_type";
export const ADMIN_UPDATE_ACCOUNT_DETAILS_FORM = "admin_update_account_details";
